import { CensusProvider } from "domain/Census";

export const ScanPageProvider = ({ children }) => <CensusProvider>{children}</CensusProvider>;
